import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { KeycloakAuthGuard, KeycloakService } from "keycloak-angular";
import { OperatorService } from "src/app/components/operator/services/operator.service";
import { UserService } from "src/app/public/onboarding/services/user.service";
import {environment} from "../../../environments/environment";

@Injectable({
    providedIn: 'root',
})

export class OperatorAuthGuard extends KeycloakAuthGuard {

    constructor(
        protected override router: Router,
        private operatorService: OperatorService,
        protected userService: UserService,
        protected keycloakService: KeycloakService
    ) {
        super(router, keycloakService);
    }


    isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        return new Promise((resolve, reject) => {
            if (!this.authenticated) {
                this.userService.clearCachedUserProfile();
                this.keycloakService.login({ redirectUri: environment.feUrl });
                return resolve(true);
            }
            this.operatorService.getOperatorStatus().subscribe(
                operator => {
                    if (operator.status === 'VALIDATED') {
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                }
            );

        });
    }

}
